import { render, staticRenderFns } from "./LayoutLanding.vue?vue&type=template&id=4030e208&scoped=true&"
var script = {}
import style0 from "./LayoutLanding.vue?vue&type=style&index=0&id=4030e208&prod&lang=scss&"
import style1 from "./LayoutLanding.vue?vue&type=style&index=1&id=4030e208&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4030e208",
  null
  
)

export default component.exports